"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/admin/user/user");
var _auth = require("@/libs/auth");
var _caLogout = require("@/libs/caLogout");
var _router = require("@/router");
var _user2 = require("@/api/user/user");
// import { resolve } from 'alias.config'

var state = {
  token: (0, _auth.getToken)(),
  name: '',
  userInfo: (0, _auth.getUserInfo)(),
  avatar: '',
  introduction: '',
  roles: [],
  userHd: '',
  businessId: "",
  roleId: '0',
  cityId: '0',
  promiseBook: 0
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_USERINFO: function SET_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  setUserHd: function setUserHd(state, userHd) {
    state.userHd = userHd;
  },
  SET_PROVIENCEID: function SET_PROVIENCEID(state, businessId) {
    state.businessId = businessId;
  },
  SET_ROLEID: function SET_ROLEID(state, roleId) {
    state.roleId = roleId;
  },
  SET_CITYID: function SET_CITYID(state, cityId) {
    state.cityId = cityId;
  }
};
var actions = {
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password,
      code = userInfo.code,
      keyId = userInfo.keyId,
      urlSign = userInfo.urlSign;
    return new Promise(function (resolve, reject) {
      (0, _user.login)({
        username: username.trim(),
        password: password,
        code: code,
        keyId: keyId,
        urlSign: urlSign
      }).then(function (response) {
        var data = response.data;
        commit('SET_TOKEN', data.access_token);
        (0, _auth.setToken)(data.access_token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  loginByToken: function loginByToken(_ref2, token) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      // 保存token
      commit('SET_TOKEN', token);
      (0, _auth.setToken)(token);

      // 获取用户信息
      (0, _user.getInfo)().then(function (response) {
        var user = response.user,
          roles = response.roles;
        var userInfo = user || '';
        if (!userInfo) {
          reject('获取用户信息失败');
          return;
        }
        commit('SET_ROLES', roles);
        commit('SET_USERINFO', userInfo);
        commit('SET_NAME', userInfo.userName);
        commit('SET_AVATAR', userInfo.avatar);
        (0, _auth.setUserInfo)(userInfo);
        resolve(userInfo);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取用户信息
  localBjcaLogin: function localBjcaLogin(_ref3, jyId) {
    var dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      (0, _user.localBjcaLogin)(jyId).then(function (response) {
        var token = response.data && response.data.access_token;
        if (!token) {
          reject(new Error('本地测试登录未返回有效 token'));
          return;
        }
        dispatch('loginByToken', token).then(resolve).catch(reject);
      }).catch(reject);
    });
  },
  getInfo: function getInfo(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)().then(function (response) {
        var user = response.user,
          roles = response.roles;
        var userInfo = user || '';
        if (!userInfo) {
          reject('验证失败，请重新登录.');
        }
        commit('SET_ROLES', roles);
        sessionStorage.setItem('info', JSON.stringify(userInfo));
        // 让Cookie携带省份信息
        // setBusinessId(data.businessId)

        // 菜单权限和角色权限合并
        // let accessArr = userInfo.businessId;
        console.log(userInfo, 'userInfo');
        commit('SET_USERINFO', userInfo);
        commit('SET_ROLEID', userInfo.roleId);
        commit('SET_NAME', userInfo.userName);
        // commit('SET_CITYID', data.cityId)
        commit('SET_AVATAR', userInfo.avatar);
        commit('SET_INTRODUCTION', userInfo.nickName);
        // commit('SET_PROVIENCEID', userInfo.businessId)
        resolve(userInfo);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref5) {
    var commit = _ref5.commit;
    sessionStorage.clear();
    commit('SET_USERINFO', '');
    commit('SET_TOKEN', '');
    commit('SET_ROLES', []);
    (0, _auth.removeToken)();
    (0, _auth.removeToken1)();
    (0, _auth.RemoveBusinessId)();
    (0, _auth.removeUserInfo)();
    (0, _auth.removeLegacyAuth)();
    // All three portal login methods share this local state and the
    // Beijing unified-authentication session must be closed as well.
    (0, _caLogout.logoutFromBeijingCa)();
  },
  // remove token
  resetToken: function resetToken(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve) {
      sessionStorage.removeItem('info');
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_USERINFO', '');
      (0, _auth.removeToken)();
      (0, _auth.removeUserInfo)();
      resolve();
    });
  },
  // 更新用户信息
  upDateUserInfo: function upDateUserInfo(_ref7, userInfo) {
    var commit = _ref7.commit;
    return new Promise(function (resolve, reject) {
      (0, _user2.upDataUserInfo)(userInfo).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};